import React from 'react';
import './Page.css';

const About = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>About Us</h1>
        <p className="page-subtitle">Your trusted septic service professionals</p>
      </div>

      <div className="content-section">
        <div className="about-content">
          <div className="about-text">
            <h2>All Around Septic Pumping, LLC</h2>
            <p>
              All Around Septic Pumping, LLC is a family-owned business. Founded and operated by owners Jeffrey Jackson and Gary Latimer, 
              we bring years of experience in the septic service industry and have built a reputation for reliability, 
              professionalism, and exceptional customer service.
            </p>
            <p>
              We understand that septic system issues can be stressful and inconvenient. That's why 
              we're committed to providing prompt, efficient service that gets your system back to 
              working order as quickly as possible.
            </p>
            <p>
              Our team of experienced professionals uses state-of-the-art equipment and follows industry 
              best practices to ensure your septic system receives the care it needs. Whether you need 
              routine maintenance, emergency service, or expert advice, we're here to help.
            </p>
          </div>

          <div className="values-section">
            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>Reliability</h3>
                <p>You can count on us to be there when you need us</p>
              </div>
              <div className="value-item">
                <h3>Quality</h3>
                <p>We never compromise on the quality of our service</p>
              </div>
              <div className="value-item">
                <h3>Integrity</h3>
                <p>Honest, transparent service you can trust</p>
              </div>
              <div className="value-item">
                <h3>Customer Focus</h3>
                <p>Your satisfaction is our top priority</p>
              </div>
              <div className="value-item">
                <h3>Serving Our Community</h3>
                <p>Proudly serving North East Texas and South East Oklahoma with dedication and care</p>
              </div>
              <div className="value-item">
                <h3>Fair Pricing</h3>
                <p>Transparent, competitive pricing that provides value without compromising quality</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;

